'use strict';

const Reflux = require('@muzzylane/reflux');

const _ = {
    find: require('lodash/find'),
    forEach: require('lodash/forEach'),
    compact: require('lodash/compact'),
    reject: require('lodash/reject'),
    cloneDeep: require('lodash/cloneDeep'),
}

const OrganizationActions = require('../actions/OrganizationActions');
const ServerRequest = require('../actions/request');
const SignInStore = require('./SignInStore');
const GlobalUserStore = require('./GlobalUserStore');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const SignInActions = require('../actions/sign_in_actions');

let organizations = {};
let orgApiInfo = {};
let orgIntegrationTags = {};
let orgTagImportChanges = {};
let orgActMetaImportChanges = {}; // org-level import changes exist here. activity tags themselves exist in ActivityStore
let orgUserSettings = {};
let orgPrivacyPolicies = {};
let orgJsonAssets = {}; // McGraw Hill websketches
let orgStudentFeedback = {};
let orgAccountFeatures = {};
let orgBoilerplate = {}; // strings for AI
let initialized = false;
let action = {};
let orgInfo = {}; //storage for "light" org info as retrieved by the OrganizationActins.orgInfo request (used only during org registration)

const UNINITIALIZED_STUDENT_FEEDBACK = {
    initializedFeedbackComments: false, // true if at least one page has been initialized
    feedback_comments: [],
    studentFeedbackPagination: {
        totalRecords: 0,
        commentSearchTerm: '',
        categorySearchTerm: '',
        sortBy: '',
        currentPage: 1,
        numPages: 1,
        filterPages: 0,
        recordsPerPage: 0,
    },
};

const OrganizationStore = Reflux.createStore({
    listenables: [OrganizationActions, SignInActions],
    init: function() {
        this.listenTo(SignInStore, this.onSignInChange);
    },

    resetState: function() {
        initialized = false;
        organizations = [];
        orgApiInfo = {};
        orgIntegrationTags = {};
        orgTagImportChanges = {};
        orgActMetaImportChanges = {};
        orgInfo = {};
        orgUserSettings = {};
        orgPrivacyPolicies = {};
        orgJsonAssets = {};
        orgStudentFeedback = {};
        orgAccountFeatures = {};
        orgBoilerplate = {};
        // action = {};
        // error = null;
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    onSignInChange: function(signInStoreState){
        // if(signInStoreState.initializedLocal){}
        return;
    },

    getState: function() {
        return {
            initialized: initialized,
            organizations: organizations,
            orgApiInfo: orgApiInfo,
            orgIntegrationTags: orgIntegrationTags,
            orgTagImportChanges: orgTagImportChanges,
            orgActMetaImportChanges: orgActMetaImportChanges,
            orgUserSettings: orgUserSettings,
            orgPrivacyPolicies: orgPrivacyPolicies,
            orgInfo: orgInfo,
            action: action,
        }
    },

    getStateOrganization: function(orgId) {
        return {
            initialized: initialized,
            organization: organizations[orgId],
            orgApiInfo: orgApiInfo[orgId],
            orgIntegrationTags: orgIntegrationTags[orgId],
            orgTagImportChanges: orgTagImportChanges[orgId],
            orgActMetaImportChanges: orgActMetaImportChanges[orgId],
            orgUserSettings: orgUserSettings[orgId],
            orgPrivacyPolicies: orgPrivacyPolicies[orgId],
            orgInfo: orgInfo[orgId],
            orgJsonAssets: orgJsonAssets[orgId],
            orgStudentFeedback: orgStudentFeedback[orgId] || _.cloneDeep(UNINITIALIZED_STUDENT_FEEDBACK),
            orgAccountFeatures: orgAccountFeatures[orgId],
            orgBoilerplate: orgBoilerplate[orgId] || null,
            action: action,
        };
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
        //error = null; //do not reset channel error
    },

    onError: function(actionID, err) {
        action.id = actionID;
        if(err.status){
            switch(err.status){
                case 404:
                    action.error = new ForgeError({message: ErrorConsts.MISSING_SECRET, stack: err.responseText || null});
                    break;
                case 400:
                    action.error = new ForgeError({ message: err.responseText, stack: null });
                    break;
                default:
                    action.error = new ForgeError({message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null});
                    break;
            }
        }
        else {
            action.error = err;
        }

        initialized = true;

        this.emitStatus();
    },

    mergeWithOrgTags: function(orgId, newTag, options={ delete: false }) {
        if (!orgIntegrationTags[orgId]) orgIntegrationTags[orgId] = [];
        let updated = false;
        let updatedOrgTags = orgIntegrationTags[orgId].map((existingTag) => {
            if (existingTag.id === newTag.id) {
                updated = true;
                if (options.delete) return null;
                return newTag;
            }

            return existingTag;
        });

        if (!updated) updatedOrgTags.push(newTag);
        orgIntegrationTags[orgId] = _.compact(updatedOrgTags);
    },

    onRegisterOrganizationCompleted: function(actionID, res) {
        // console.log("onRegisterOrganizationCompleted: ", actionID, res);
        action = { id: actionID };
        this.emitStatus();
    },

    onRegisterOrganizationFailed: function(actionID, err) {
        console.warn("onRegisterOrganizationFailed: ", actionID, err);
        action = { id: actionID, error: err };
        this.emitStatus();
    },

    onValidateOrganizationCompleted: function(actionID, res) {
        // console.log("onValidateOrganizationCompleted: ", actionID, res);
        //DO SOMETHING
        action = {id: actionID};
        this.emitStatus();
    },

    onValidateOrganizationFailed: function(actionID, err) {
        console.warn("onValidateOrganizationFailed: ", actionID, err);
        this.onError(actionID, err);
    },

    onRemoveOrganizationMemberCompleted: function(actionID, res) {
        // console.log("onRemoveOrganizationMemberCompleted: ", actionID, res);
        //DO SOMETHING
        action = {};
        action.id = actionID;
        this.emitStatus();
    },

    onRemoveOrganizationMemberFailed: function(actionID, err) {
        console.warn("onRemoveOrganizationMemberFailed: ", actionID, err);
        this.onError(actionID, err);
    },

    onOrgInfoCompleted: function(actionID, res) {
        // console.log("onOrgInfoCompleted: ", actionID, res);
        orgInfo = res;
        action = {id: actionID};
        this.emitStatus();
    },

    onOrgInfoFailed: function(actionID, err) {
        console.warn("onOrgInfoFailed: ", actionID, err);
        this.onError(actionID, err);
    },

    onGetOrgInfoFullCompleted: function(actionID, res) {
        // console.log("onGetOrgInfoFullCompleted: ", actionID, res);
        organizations[res.id] = res;
        action = {id: actionID};
        this.emitStatus();
    },

    onGetOrgInfoFullFailed: function(actionID, err) {
        console.warn("onGetOrgInfoFullFailed: ", actionID, err);
        this.onError(actionID, err);
    },

    onGetOrgApiInfoCompleted: function(actionId, orgId, res) {
        // console.log("onGetOrgApiInfoCompleted: ", actionId, res);
        orgApiInfo[orgId] = res;
        action = { id: actionId };
        this.emitStatus();
    },

    onGetOrgApiInfoFailed: function(actionId, orgId, err) {
        console.warn("onGetOrgApiInfoFailed: ", actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateOrgInfoCompleted: function(actionId, orgId, orgInfo) {
        // console.log('onUpdateOrgInfoCompleted: ', actionId, orgId, orgInfo);
        action = { id: actionId };
        organizations[orgId] = orgInfo;
        this.emitStatus();
    },

    onUpdateOrgInfoFailed: function(actionId, orgId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetOrgIntegrationTagsCompleted: function(actionId, orgId, tags) {
        // console.log('onGetOrgIntegrationTagsCompleted: ', actionId, orgId, tags);
        action = { id: actionId };
        orgIntegrationTags[orgId] = tags;
        this.emitStatus();
    },

    onGetOrgIntegrationTagsFailed: function(actionId, orgId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddOrgIntegrationTagCompleted: function(actionId, orgId, tag) {
        // console.log('onAddOrgIntegrationTagCompleted: ', actionId, orgId, orgInfo);
        action = { id: actionId };
        this.mergeWithOrgTags(orgId, tag);
        this.emitStatus();
    },

    onAddOrgIntegrationTagFailed: function(actionId, orgId, err) {
        console.warn('onAddOrgIntegrationTagFailed: ', actionId, orgId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateOrgIntegrationTagCompleted: function(actionId, orgId, tag) {
        // console.log('onUpdateOrgIntegrationTagCompleted: ', actionId, orgId, tag);
        action = { id: actionId };
        this.mergeWithOrgTags(orgId, tag);
        this.emitStatus();
    },

    onUpdateOrgIntegrationTagFailed: function(actionId, orgId, err) {
        console.warn('onUpdateOrgIntegrationTagFailed: ', actionId, orgId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onDeleteOrgIntegrationTagCompleted: function(actionId, orgId, tagId, res) {
        // console.log('onUpdateOrgIntegrationTagCompleted: ', actionId, orgId, tag);
        action = { id: actionId };
        this.mergeWithOrgTags(orgId, { id: tagId }, { delete: true });
        this.emitStatus();
    },

    onDeleteOrgIntegrationTagFailed: function(actionId, orgId, tagId, err) {
        console.warn('onUpdateOrgIntegrationTagFailed: ', actionId, orgId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onImportIntegrationTagsCsvCompleted: function(actionId, orgId, changes) {
        // console.log('onImportIntegrationTagsCsvCompleted: ', actionId, orgId, changes);
        action = { id: actionId };
        orgTagImportChanges[orgId] = changes;
        this.emitStatus();
    },

    onImportIntegrationTagsCsvFailed: function(actionId, orgId, err) {
        console.warn('onImportIntegrationTagsCsvFailed: ', actionId, orgId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onClearImportIntegrationTagChangesCompleted: function(actionId, orgId) {
        // console.log('onClearImportIntegrationTagChangesCompleted: ', actionId, orgId);
        action = { id: actionId };
        if (orgTagImportChanges[orgId]) delete orgTagImportChanges[orgId];
        this.emitStatus();
    },

    onConfirmImportIntegrationTagChangesCompleted: function(actionId, orgId, tags) {
        // console.log('onConfirmImportIntegrationTagChangesCompleted: ', actionId, orgId, tags);
        action = { id: actionId };
        orgIntegrationTags[orgId] = tags;
        if (orgTagImportChanges[orgId]) delete orgTagImportChanges[orgId];
        this.emitStatus();
    },

    onConfirmImportIntegrationTagChangesFailed: function(actionId, orgId, err) {
        console.warn('onConfirmImportIntegrationTagChangesFailed: ', actionId, orgId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onImportActMetaTagsCsvCompleted: function(actionId, orgId, categoryId, changes) {
        // console.log('onImportActMetaTagsCsvCompleted: ', actionId, orgId, categoryId, changes);
        action = { id: actionId };
        if (!orgActMetaImportChanges[orgId]) orgActMetaImportChanges[orgId] = {};
        orgActMetaImportChanges[orgId][categoryId] = changes;
        this.emitStatus();
    },

    onImportActMetaTagsCsvFailed: function(actionId, orgId, categoryId, err) {
        console.warn('onImportActMetaTagsCsvFailed: ', actionId, orgId, categoryId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onClearImportActMetaTagChangesCompleted: function(actionId, orgId, categoryId) {
        // console.log('onClearImportActMetaTagChangesCompleted: ', actionId, orgId, categoryId);
        action = { id: actionId };
        if (!!orgActMetaImportChanges[orgId] && orgActMetaImportChanges[orgId][categoryId]) delete orgActMetaImportChanges[orgId][categoryId];
        this.emitStatus();
    },

    onConfirmImportActMetaTagChangesCompleted: function(actionId, orgId, categoryId, tags) { // same functionality as onClearImportActMetaTagChangesCompleted. tags are kept in ActivityStore
        // console.log('onConfirmImportActMetaTagChangesCompleted: ', actionId, orgId, categoryId, tags);
        action = { id: actionId };
        if (!!orgActMetaImportChanges[orgId] && orgActMetaImportChanges[orgId][categoryId]) delete orgActMetaImportChanges[orgId][categoryId];
        this.emitStatus();
    },

    onConfirmImportActMetaTagChangesFailed: function(actionId, orgId, categoryId, err) {
        console.warn('onConfirmImportActMetaTagChangesFailed: ', actionId, orgId, categoryId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetOrgUserSettingsCompleted: function(actionId, orgId, res) {
        action = { id: actionId };
        orgUserSettings[orgId] = res;
        this.emitStatus();

    },
    onGetOrgUserSettingsFailed: function(actionId, orgId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    onUpdateOrgUserSettingsCompleted: function(actionId, orgId, res) {
        action = { id: actionId };
        orgUserSettings[orgId] = res;
        this.emitStatus();

    },
    onUpdateOrgUserSettingsFailed: function(actionId, orgId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    onUpdateOrgCustomConfigCompleted: function(actionId, orgId, res) {
        action = { id: actionId };
        orgUserSettings[orgId] = res;
        this.emitStatus();

    },
    onUpdateOrgCustomConfigFailed: function(actionId, orgId, err) {
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetOrgPrivacyPoliciesCompleted: function(actionId, orgId, res) {
        action = { id: actionId };
        orgPrivacyPolicies[orgId] = res;
        this.emitStatus();
    },

    onGetOrgPrivacyPoliciesFailed: function(actionId, orgId, err) {
        console.warn('onGetOrgPrivacyPoliciesFailed: ', actionId, orgId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAddOrgPrivacyPolicyCompleted: function(actionId, orgId, res) {
        // console.log('onAddOrgPrivacyPolicyCompleted: ', actionId, orgId, res);
        action = { id: actionId };
        if (!orgPrivacyPolicies[orgId]) orgPrivacyPolicies[orgId] = [];
        orgPrivacyPolicies[orgId].push(res);
        console.log('new policy arr', orgPrivacyPolicies[orgId]);
        this.emitStatus();
    },

    onAddOrgPrivacyPolicyFailed: function(actionId, orgId, err) {
        console.warn('onAddOrgPrivacyPolicyFailed: ', actionId, orgId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateOrgPrivacyPolicyCompleted: function(actionId, orgId, privacyPolicyId, res) {
        action = { id: actionId };
        if (!orgPrivacyPolicies[orgId]) orgPrivacyPolicies[orgId] = [];
        
        orgPrivacyPolicies[orgId] = orgPrivacyPolicies[orgId].map((policy) => {
            if (policy.privacy_policy_id === privacyPolicyId) return res;

            return policy;
        });
        this.emitStatus();
    },

    onUpdateOrgPrivacyPolicyFailed: function(actionId, orgId, privacyPolicyId, err) {
        console.warn('onUpdateOrgPrivacyPolicyFailed: ', actionId, orgId, privacyPolicyId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onDeleteOrgPrivacyPolicyCompleted: function(actionId, orgId, privacyPolicyId, res) {
        action = { id: actionId };
        if (!orgPrivacyPolicies[orgId]) orgPrivacyPolicies[orgId] = [];

        orgPrivacyPolicies[orgId] = _.reject(orgPrivacyPolicies[orgId], (policy) => policy.privacy_policy_id === privacyPolicyId);
        this.emitStatus();
    },

    onDeleteOrgPrivacyPolicyFailed: function(actionId, orgId, privacyPolicyId, err) {
        console.warn('onDeleteOrgPrivacyPolicyFailed: ', actionId, orgId, privacyPolicyId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onGetOrgJsonAssetsCompleted: function(actionId, orgId, res) {
        action = { id: actionId };
        orgJsonAssets[orgId] = res;
        this.emitStatus();
    },
    
    onGetOrgJsonAssetsFailed: function(actionId, orgId, err) {
        console.warn('onGetOrgJsonAssetsFailed: ', actionId, orgId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onAddOrgAssetCompleted: function(actionId, params, res) {
        action = { id: actionId };
        const orgId = params.org_id;
        const name = params.asset_name;
        const url = res.url;
        const date = new Date().toISOString();
        action.name = name;
        action.url = url;
        if (params.assetType === 'json') {
            // construct data for orgJsonAssets
            if (!orgJsonAssets[orgId]) {
                orgJsonAssets[orgId] = [];
            }
            if (!orgJsonAssets[orgId].find((entry)=>{ return entry.url === url })) {
                orgJsonAssets[orgId].push({name,url,date});
            }
        }
        else if (params.assetType === 'image') {
            // handled by caller (uses action.url)
        }
        this.emitStatus();
    },
    
    onAddOrgAssetFailed:  function(actionId, params, err) {
        console.warn('onAddOrgAssetFailed: ', actionId, params, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onGetOrgStudentFeedbackCompleted: function(actionId, orgId, res) {
        // console.log('onGetOrgStudentFeedbackCompleted: ', actionId, res);
        action = { id: actionId };
        
        let { /*feedback_comments,*/ studentFeedbackPagination, /*initializedFeedbackComments,*/ ...theRest } = ( orgStudentFeedback[orgId] || _.cloneDeep(UNINITIALIZED_STUDENT_FEEDBACK) )

        const feedback_comments = res.records;
        studentFeedbackPagination.totalRecords = res.totalRecords;
        studentFeedbackPagination.commentSearchTerm = res.commentSearchTerm;
        studentFeedbackPagination.categorySearchTerm = res.categorySearchTerm;
        studentFeedbackPagination.sortBy = res.sortBy;
        studentFeedbackPagination.recordsPerPage = res.recordsPerPage;
        studentFeedbackPagination.currentPage = 1;
        studentFeedbackPagination.numPages = 1;
        studentFeedbackPagination.filterPages = 1;
        studentFeedbackPagination.matchingRecords = res.totalRecords;
        if (res.totalRecords >  res.records.length) {
            studentFeedbackPagination.matchingRecords = res.records.length;
            studentFeedbackPagination.currentPage = res.currentPage;
            studentFeedbackPagination.numPages = Math.ceil(res.totalRecords / res.recordsPerPage);
            studentFeedbackPagination.filterPages = Math.ceil(res.matchingRecords / res.recordsPerPage);
        }
        const initializedFeedbackComments = true;
        
        orgStudentFeedback[orgId] = { feedback_comments, studentFeedbackPagination, initializedFeedbackComments, ...theRest };
        this.emitStatus();
    },

    onGetOrgStudentFeedbackFailed: function(actionId, orgId, err) {
        console.warn('onGetOrgStudentFeedbackFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onUpdateOrgStudentFeedbackCompleted: function(actionId, orgId, res) {
        //console.log('onUpdateOrgStudentFeedbackCompleted: ', actionId, res);
        action = { id: actionId };
        
        let { feedback_comments, ...theRest } = ( orgStudentFeedback[orgId] || _.cloneDeep(UNINITIALIZED_STUDENT_FEEDBACK) )
        
        let entry = _.find(feedback_comments,{id:res.id});
        if (entry) {
            if (res.category_id) {
                entry.category_id = res.category_id;
            }
            if (res.assignee_id) {
                entry.assignee_id = res.assignee_id;
                entry.assigned_user_display_name = res.assigned_user_display_name;
                entry.assigned_user_last_name = res.assigned_user_last_name;
                entry.assigned_user_first_name = res.assigned_user_first_name;
            }
            if (res.status) {
                entry.status = res.status;
            }
        }

        orgStudentFeedback[orgId] = { feedback_comments, ...theRest };

        this.emitStatus();
    },

    onUpdateOrgStudentFeedbackFailed: function(actionId, orgId, err) {
        console.warn('onUpdateOrgStudentFeedbackFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onGetOrgAccountFeaturesCompleted: function(actionId, orgId, res) {
        //console.log('onGetOrgAccountFeaturesCompleted: ', actionId, res);
        action = { id: actionId };
        orgAccountFeatures[orgId] = res;
        this.emitStatus();
    },
    
    onGetOrgAccountFeaturesFailed: function(actionId, orgId, err) {
        console.warn('onGetOrgAccountFeaturesFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onUpdateOrgAccountFeaturesCompleted: function(actionId, orgId, res) {
        //console.log('onUpdateOrgAccountFeaturesCompleted: ', actionId, res);
        action = { id: actionId };
        orgAccountFeatures[orgId] = res;
        this.emitStatus();
    },
    
    onUpdateOrgAccountFeaturesFailed: function(actionId, orgId, err) {
        console.warn('onUpdateOrgAccountFeaturesFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onGetOrgBoilerplateCompleted: function(actionId, orgId, res) {
        //console.log('onGetOrgBoilerplateCompleted: ', actionId, res);
        action = { id: actionId };
        orgBoilerplate[orgId] = res;
        this.emitStatus();
    },
    
    onGetOrgBoilerplateFailed: function(actionId, orgId, err) {
        console.warn('onGetOrgBoilerplateFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onUpdateOrgBoilerplateEntryCompleted: function(actionId, orgId, res) {
        //console.log('onUpdateOrgBoilerplateEntryCompleted: ', actionId, res);
        action = { id: actionId };
        let {/*org_id,*/ string_id, string_value} = res;
        let ai_boilerplate = {};
        if (orgAccountFeatures[orgId]) {
            ai_boilerplate = { ... orgBoilerplate[orgId] }
        }
        if (string_value === null) { // Note: empty string = normal behavior, null value = delete
            delete ai_boilerplate[string_id];
        }
        else {
            ai_boilerplate[string_id] = string_value;
            orgBoilerplate[orgId] = ai_boilerplate;
        }
        this.emitStatus();
    },
    
    onUpdateOrgBoilerplateEntryFailed: function(actionId, orgId, err) {
        console.warn('onUpdateOrgBoilerplateEntryFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    
});

module.exports = OrganizationStore;
